import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import editHealthResourcesDialog from './dialog.editHealthResourcesDialog';
import controller from './health-resources.controller';
import directive from './health-resources.directive';


export default angular.module('app.components.advisory.bcp.healthResources', [
  alerts,
  bcpDataService,
  confirmDialog,
  constants,
  editHealthResourcesDialog,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('bcpHealthResources', directive)
  .controller('HealthResourcesController', controller)
  .name;

console.log('app.components.advisory.bcp.healthResources created');
